import { createFileRoute } from '@tanstack/react-router'
import { BansosManager } from '../../../../components/BansosManager'

export const Route = createFileRoute('/platform/desa/$desaId/bansos')({
  component: () => {
    const { desaId } = Route.useParams()
    return <BansosManager desaId={desaId} />
  },
})
